import React from 'react';
const PURCHASE_URL = 'https://digitalespro.com/cart/47867900788950:1';
export function FooterSection() {
  return <footer className="bg-gray-900 text-white py-16 px-4 text-center" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <h2 className="text-3xl font-black mb-6 font-['Oswald'] uppercase" data-id="element-53">
          Enseñar Ciencias puede ser más simple
        </h2>

        <p className="text-xl text-gray-400 mb-8" data-id="element-54">
          No necesitás más PDFs sueltos. Necesitás un sistema que te acompañe
          todo el año.
        </p>

        <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="bg-[#f39c12] hover:bg-[#e67e22] text-white text-xl font-bold py-4 px-8 rounded shadow-[0_4px_0_#d35400] active:shadow-[0_2px_0_#d35400] active:translate-y-1 transition-all uppercase mb-12 inline-block no-underline" data-id="element-55">
          👉 Accedé ahora al Pack Completo
        </a>

        <div className="border-t border-gray-800 pt-8 text-sm text-gray-500" data-id="element-56">
          <p className="mb-2" data-id="element-57">
            © 2026 El Asombroso Viaje por el Cuerpo Humano
          </p>
          <p data-id="element-58">
            Todos los derechos reservados. Privacidad · Términos y Condiciones
          </p>
        </div>
      </div>
    </footer>;
}